import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { styles } from './profile-styles';
import { styles as sharedStyles } from '../../styles/shared-styles';
import '@shoelace-style/shoelace/dist/components/card/card.js';
import { WithUserProfileConsumer } from '../../mixins/with-user-profile-consumer';
import '../../components/shop-access.js';
import { Base64BlobUrl } from '../../utility/base64-blob-url';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement('app-profile')
export class AppProfile extends WithUserProfileConsumer(LitElement) {
  static styles = [sharedStyles, styles];
  @state()
  private _profileBlobUrl = new Base64BlobUrl();
  doUserProfileChanged() {
    console.log('doUserProfileChanged: BottomNav');
    this._profileBlobUrl.dispose();
    this._profileBlobUrl = new Base64BlobUrl(
      this.userProfile?.profileImageBase64
    );
  }
  render() {
    return html`
      ${
        this.userProfile
          ? html`
              <p>Welcome, ${this.userProfile.displayName}!</p>
              <sl-card>
                <img
                  slot="image"
                  src=${ifDefined(this._profileBlobUrl.blobUrl)}
                  alt="Your avatar"
                />
                <h2>Your Profile Information</h2>
                <p>Name: ${this.userProfile.displayName}</p>
                <p>Email: ${this.userProfile.emailAddress}</p>
                <h3>Shops</h3>
                <ul>
                  ${this.userProfile.shopAccess.map(
                    (shop) => html`<shop-access .shop=${shop}></shop-access>`
                  )}
                </ul>
              </sl-card>
            `
          : html`<p>Please log in</p>`
      }
    `;
  }
}
